module.exports = __webpack_public_path__ + "static/img/dog-2.7c7a8ee4.png";